import AWS from 'aws-sdk';
import { createClient } from '@supabase/supabase-js';

// Supabase Configuration
export const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  'https://gerwwwimiczukwkxgvqc.supabase.co';
export const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdlcnd3d2ltaWN6dWt3a3hndnFjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI5NTc0MTAsImV4cCI6MjA3ODUzMzQxMH0.4QIbB48FXt1RL7Q9a5OeHZiF1Yj34SxbSvv1d0rSFWQ';

export const supabaseProjectId = 'gerwwwimiczukwkxgvqc';

// Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public',
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'x-client-info': 'paparazzo-app',
    },
  },
});

// Storage Configuration (existing)
// Nota: In produzione usa la CDN di DigitalOcean Spaces
// Per demo/sviluppo usiamo placeholder semplici e affidabili
export const screenshotBasePath = 'https://picsum.photos/';
export const storageConfig = {
  s3: {
    endpoint: 'fra1.digitaloceanspaces.com',
    useAccelerateEndpoint: false,
    credentials: new AWS.Credentials(
      'DO00FVLJ78FHMDVXAHXJ',
      'Wy BRlmH9gKbcam9K/sHeqUvm4ql/9i5IfSFDhwFu7uI',
    ),
  },
};

// Cache Configuration (existing)
export const cacheOrdersLastFetchKey = 'pzo__orders_last_fetch_time';
export const cacheOrdersKey = 'pzo__orders';
export const cacheOrdersLastShootedKey = 'pzo__orders_last_shooted';
export const cacheOrdersTTLmsec = 3 * 60e3;

//export const cacheOrdersTTLmsec = 10e3;
